<div class="not-found">
  <div class="text-center">
      <img class="img-responsive center-block header-logo my-5 " src="https://firebasestorage.googleapis.com/v0/b/bimboakibadev.appspot.com/o/logos%2FLogo_Grupo_BIMBO.svg?alt=media&token=b57a2235-a83d-4fe0-b313-491cfdd00ec5" />
  </div>

  <div class="row mt-4 mb-4">
      <div class="col-md-12 text-center noActions">
          <h5>La pagina que se busco no existe</h5>
          <mat-icon aria-hidden="true" class="my-5">error_outline</mat-icon>
          <h5>No es necesario reportarlo</h5>
      </div>
  </div>

</div>
